/* eslint-disable */

export const testCatGrpMsku = `query testCGM($stype: String!, $sku_key: String!) {
  testCatGrpMsku(stype: $stype, sku_key: $sku_key) {
      schg
      sku_key
} }`;

/* list of channels */
export const chanChoiceList = `query queryChoiceChan($rlimit: Int, $nextToken: String ) {
  listChannels(limit: $rlimit, nextToken: $nextToken) {
      nextToken
      items {
          atype
          chtype
          channelid
      }
} }`;

// list of channels with more info
export const chanFullList = `query queryChoiceChan($rlimit: Int, $nextToken: String ) {
  listChannels(limit: $rlimit, nextToken: $nextToken) {
      nextToken
      items {
          atype
          chtype
          channelid
          chkey
          chlink
          chdisable
          chqueue
      }
} }`;

/* single channel with full info */
export const chanItemInfo = `query queryChan($currchan: String! ) {
  getChanInfo(atype: $currchan) {
      atype
      chtype
      channelid
      chkey
      chlink
      chdisable
      chqueue
 } }`;

/* root and additional users (2 queries) */
export const allUsersInfo = `query queryUsers {
  getRootUser {
      userid
      perm
      nname
  }
  listUsers {
      userid
      perm
      nname
      adisable
      agroups
 } }`;

/* current user */
export const currUsersInfo = `query queryUsers {
  getCurrentUser {
      userid
      perm
      nname
      adisable
      agroups
 } }`;


/* rpt detail */
export const reportsDetailList = `query queryRptsDet($creport: String!, $rlimit: Int, $nextToken: String, $sortd: String ) {
  listRptHistory(cidreport: $creport) {
      cidreport
      rport
      aureqlock
      aurptlock
      autopull
      auhours
      aunotafter
      aunotbefore
      difftopic
      almtopic
      almflds
      ignflds
      keyname
      passrecs
      lastreqdate
      lastrptdate
      nname
      pullbuck
      reportid
      requestid
      disable_request
      sku_master
      sku_master_force
      sku_summ
      sku_summ_rem
      sku_igndetflds
      sku_search
      chmeth
      chauth_type
      chreqtype
      chauth_hdr
      chdtype
      chendpt
      chepath
      chflatflds
      chflatten
      chflatlev
      chmparms
      chpagnat
      chquery
      rptdetail(limit: $rlimit, nextToken: $nextToken, sortd: $sortd) {
          nextToken
          items {
              cidreport
              fchg
              cidfchg
              rport
              md5ddup
              status
              requestid
              reportid
              uid
              uname
              pullbuck
              pullbuckname
              difftot
              diffadd
              diffchg
              diffdel
              diffrptid
          }
      }
} }`;

/* rpt list auto index */
export const reportsAutoList = `query queryReportsAuto($rlimit: Int, $nextToken: String ) {
  listReports(limit: $rlimit, nextToken: $nextToken) {
      nextToken
      items {
          cidreport
          fchg
          cidfchg
          rport
          auhours
          aureqlock
          autopull
          difftopic
          ignflds
          lastreqdate
          lastrptdate
          nname
          pullbuck
          reportid
          requestid
          disable_request
          sku_master_force
          sku_summ
          sku_summ_rem
          chmeth
          chauth_type
          chdtype
          chendpt
          chepath
          chflatflds
          chflatten
          chmparms
          chpagnat
          chquery
      }
} }`;

/* mwsoffer detail */
export const chanAsinChgQuery = `query queryChan($currasin: String!, $currchan: String!, $rlimit: Int, $nextToken: String ) {
  listOfferAsin(atype: $currchan) {
      atype
      channelid
      mwsoffer(asin: $currasin, limit: $rlimit, nextToken: $nextToken) {
          nextToken
          items {
              ochg
              asin
              pub
              mcnt
              ocnt
              rank
              bbamt
              bbsid
              reason
              unote
              mcnt
              qcnt
              ocnt
              ucnt
              map
              bbsid
              fbaamt
              fbmamt
          }
      }
 } }`;

/* list mwsoffer */
export const chanChgQuery = `query queryChan($currchan: String!, $rlimit: Int, $nextToken: String ) {
  listOfferChg(atype: $currchan) {
      atype
      channelid
      mwsoffer(limit: $rlimit, nextToken: $nextToken) {
          nextToken
          items {
              asin
              pub
              mcnt
              ocnt
              rank
              bbamt
              bbsid
              reason
              unote
              mcnt
              qcnt
              ocnt
              ucnt
              map
              bbsid
              fbaamt
              fbmamt
          }
      }
 } }`;

/* -------------------CATEGORIES-----------------  */
/* cat list, pid.._CAT_ */
export const skuCatQuery = `query queryCat($sku_key: String, $rlimit: Int, $nextToken: String ) {
    listCatSku(sku_key: $sku_key, limit: $rlimit, nextToken: $nextToken) {
        nextToken
        items {
            sku_key
            grplink {
              schg
            }
        }
 } }`;
export const skuCatFullQuery = `query queryCat($sku_key: String, $rlimit: Int, $nextToken: String ) {
    listCatSku(sku_key: $sku_key, limit: $rlimit, nextToken: $nextToken) {
        nextToken
        items {
            sku_key
            grplink {
              schg
              grpsku {
                mainlink {
                  schg
                }
              }
            }
        }
 } }`;

/* list of categories for a given group */
export const grpCatQuery = `query queryCat($grp_key: String!, $rlimit: Int, $nextToken: String ) {
    listGrpCat(grp_key: $grp_key, limit: $rlimit, nextToken: $nextToken) {
        nextToken
        items {
            sku_key
        }
 } }`;

/* -------------------GROUPS-------------------  */
/* list of groups for a given msku
      this uses index and can get peers on each group
*/
export const mskuGrpQuery = `query queryGrp($sku_key: String!, $rlimit: Int, $nextToken: String ) {
    listMskuGrp(sku_key: $sku_key, limit: $rlimit, nextToken: $nextToken) {
        nextToken
        items {
            sku_key
        }
 } }`;

/* group info, pid..gname on main table*/
export const skuCatInfoQuery = `query queryCat($sku_key: String!, $rlimit: Int, $nextToken: String ) {
    listCatInfo(sku_key: $sku_key, limit: $rlimit, nextToken: $nextToken) {
        nextToken
        items {
            schg
            grpsku {
                schg
                mainlink {
                    schg
                }
            }
        }
 } }`;

/* group list, pid._GROUP_ on parsidschg index */
export const skuGrpQuery = `query queryGrp($sku_key: String, $rlimit: Int, $nextToken: String ) {
    listGrpSku(sku_key: $sku_key, limit: $rlimit, nextToken: $nextToken) {
        nextToken
        items {
            sku_key
            mainlink {
              schg
            }
        }
 } }`;

/* group list, w/ category uplook */
export const skuGrpCatQuery = `query queryGrp($sku_key: String, $rlimit: Int, $nextToken: String ) {
    listGrpSku(sku_key: $sku_key, limit: $rlimit, nextToken: $nextToken) {
        nextToken
        items {
            sku_key
            mainlink {
              schg
            }
            catlink {
              sku_key
            }
        }
 } }`;

/* group info, pid.gname on main table*/
export const skuGrpInfoQuery = `query queryGrp($sku_key: String!, $rlimit: Int, $nextToken: String ) {
    listGrpInfo(sku_key: $sku_key, limit: $rlimit, nextToken: $nextToken) {
        nextToken
        items {
            schg
        }
 } }`;



/* main sku list with summary info */
export const skuAllQuery = `query querySku($rlimit: Int, $nextToken: String ) {
  listMskuSumm(limit: $rlimit, nextToken: $nextToken) {
      nextToken
      items {
          sku_key
          lastupd
          ven
          inv_qty
          alcost
          afnsku
          fba_qty
          asin
          fbm_avail
          base_avail
  } } }`;

/* main sku list, pid-_SUMMARY_ */
export const skuFullQuery = `query querySku($sku_key: String, $rlimit: Int, $nextToken: String ) {
  listMainSku(sku_key: $sku_key, limit: $rlimit, nextToken: $nextToken) {
      nextToken
      items {
          sku_key
          lastupd
          compsku {
              __typename
                  parsidschg
                  sku_key
                  schg
                  lastupd
                  ... on CompBase {
                      chsku
                      baseid
                      ch_qty
                      ch_price
                      }
                  ... on CompFba {
                      chsku
                      fba_qty
                      afnsku
                      fba_avail
                      fba_inbd
                      arec_qty
                      }
                  ... on CompFbm {
                      chsku
                      asin
                      ch_qty
                      ch_price
                      }
                  ... on CompDef {
                      lastchk
                      inv_qty
                      ven
                      sgroup
                      alcost
                      }
                  ... on CompSumm {
                      afnsku
                      alcost
                      asin
                      base_avail
                      fba_qty
                      fbm_avail
                      inv_qty
                      ven
                      }
  } } } }`;

/* main sku list, pid-_SUMMARY_ */
export const skuExactQuery = `query querySku($sku_key: String!) {
  getMainSku(sku_key: $sku_key) {
      sku_key
      lastupd
      compsku {
          __typename
              parsidschg
              sku_key
              schg
              lastupd
              ... on CompBase {
                  chsku
                  baseid
                  ch_qty
                  ch_price
                  }
              ... on CompFba {
                  chsku
                  fba_qty
                  afnsku
                  fba_avail
                  fba_inbd
                  arec_qty
                  }
              ... on CompFbm {
                  chsku
                  asin
                  ch_qty
                  ch_price
                  }
              ... on CompDef {
                  lastchk
                  inv_qty
                  ven
                  sgroup
                  alcost
                  }
              ... on CompSumm {
                  afnsku
                  alcost
                  asin
                  base_avail
                  fba_qty
                  fbm_avail
                  inv_qty
                  ven
                  }
  } } }`;

/* link sku-comp list, pid-cid-chansku */
export const skuCompQuery = `query querySku($cidchsku: String!) {
  listLinkSku(cidchsku: $cidchsku) {
    __typename
    parsidschg
    sku_key
    schg
    lastupd
    ... on CompSysDef {
        rptsku {
            __typename
            parsidschg
            schg
            sku_key
            ... on RptChg {
                chgnote
                chgrpt
                }
            }
        }
    ... on CompBase {
        chsku
        baseid
        ch_qty
        ch_price
        rptsku {
            __typename
            parsidschg
            schg
            sku_key
            ... on RptChg {
                chgnote
                chgrpt
                }
            }
        }
    ... on CompFba {
        chsku
        fba_qty
        afnsku
        fba_avail
        fba_inbd
        arec_qty
        rptsku {
            __typename
            parsidschg
            schg
            sku_key
            ... on RptChg {
                chgnote
                chgrpt
                }
            }
        }
    ... on CompFbm {
        chsku
        asin
        ch_qty
        ch_price
        rptsku {
            __typename
            parsidschg
            schg
            sku_key
            ... on RptChg {
                chgnote
                chgrpt
                }
            }
        }
    ... on CompDef {
        lastchk
        inv_qty
        ven
        sgroup
        alcost
        rptsku {
            __typename
            parsidschg
            schg
            sku_key
            ... on RptChg {
                chgnote
                chgrpt
                }
            }
        }
  } }`;

/* mainsku info , pid-msku */
export const skuCdirectQuery = /* GraphQL */ `
  query querySku($sku_key: String!, $rlimit: Int, $nextToken: String) {
  listSysSku(sku_key: $sku_key, limit: $rlimit, nextToken: $nextToken) {
    nextToken
    items {
      __typename
      parsidschg
      sku_key
      schg
      lastupd
      ... on CompSysDef {
          rptsku {
              __typename
              parsidschg
              schg
              sku_key
              ... on RptChg {
                  chgnote
                  chgrpt
                  }
              }
          }
      ... on CompBase {
          chsku
          baseid
          ch_qty
          ch_price
          rptsku {
              __typename
              parsidschg
              schg
              sku_key
              ... on RptChg {
                  chgnote
                  chgrpt
                  }
              }
          }
      ... on CompFba {
          chsku
          fba_qty
          afnsku
          fba_avail
          fba_inbd
          arec_qty
          rptsku {
              __typename
              parsidschg
              schg
              sku_key
              ... on RptChg {
                  chgnote
                  chgrpt
                  }
              }
          }
      ... on CompFbm {
          chsku
          asin
          ch_qty
          ch_price
          rptsku {
              __typename
              parsidschg
              schg
              sku_key
              ... on RptChg {
                  chgnote
                  chgrpt
                  }
              }
          }
      ... on CompDef {
          lastchk
          inv_qty
          ven
          sgroup
          alcost
          rptsku {
              __typename
              parsidschg
              schg
              sku_key
              ... on RptChg {
                  chgnote
                  chgrpt
                  }
              }
          }
    }

  } }`;



